import {useEffect, useState} from 'react'
import {getVideoIdentity} from '../utils/utils'

/**
 * Tracks whether a video asset can currently play, resetting to true whenever a genuinely
 * different video replaces it so a fresh video isn't stuck hidden by a previous one's error.
 *
 * @param {object} [asset] - Video asset.
 * @returns {[boolean, Function]} Whether the video is playable, and an error handler that clears it.
 * @example
 * const [playable, onVideoError] = usePlayableVideo(asset)
 */
const usePlayableVideo = (asset) => {
    const [playable, setPlayable] = useState(true)
    const videoIdentity = getVideoIdentity(asset)

    // a mounted module can get another video: the MomentVM editor preview replaces modules in
    // place, and modules are keyed by index, so client-side navigation reuses a module at the
    // same position
    useEffect(() => {
        setPlayable(true)
    }, [videoIdentity])

    return [playable, () => setPlayable(false)]
}

export default usePlayableVideo
